import React from 'react';

function ExtraRow({ item }) {
  return <div className="detail container panel-row panel-item panel-item--extra">{item}</div>;
}

function ExtrasPanel({ extras, loading }) {
  return (
    <div className="glass container panel-fit extras-panel" style={{ justifyContent: 'flex-start' }}>
      <h1>הוספות לתפילה</h1>
      <div className="container panel-content panel-content-static" style={{ justifyContent: 'flex-start', textAlign: 'start' }}>
        {extras.length ? (
          extras.map((item, index) => <ExtraRow key={`${item}-${index}`} item={item} />)
        ) : (
          <div className="panel-placeholder">{loading ? 'טוען מידע...' : 'אין מידע להצגה'}</div>
        )}
      </div>
    </div>
  );
}

export default React.memo(ExtrasPanel);
